async function addSubscriptionItem(variantId, subscriptionPlanId) {
  await fetch("/cart/add.json", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      body: JSON.stringify({
          id: variantId,
          subscription_plan: subscriptionPlanId,
          quantity: 1
      })
  })
  window.location.replace(window.location.href);
	window.location.reload();
}

async function addQuarterSubscriptionItem() {
  await addSubscriptionItem(39610612809827);
}

async function addAnnualSubscriptionItem() {
  await addSubscriptionItem(39618618130531);
}

async function clearCart() {
  await fetch("/cart/clear.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    }
  })
}

async function logout(){
  openLogout();
  console.log("logout");
  await clearCart();
  setTimeout(function(){ window.location = '/account/logout'; }, 2500);
  //window.location = '/account/logout';
}

function openModal(id) {
  document.querySelector(`#${id}`).style.display = "flex";
  document.body.classList.add('is-modal-open', 'overflow-hidden');
}

function closeModal(id) {
  document.querySelector(`#${id}`).style.display = "none";
  document.body.classList.remove('is-modal-open', 'overflow-hidden');
}

function reloadPage() {
  setTimeout(function(){
    window.location.reload();
  }, 2500);
}

function saveDataStorage(id, data) {
  try {
    const serializedData = JSON.stringify(data)
    window.localStorage.setItem(id, serializedData)
  } catch (e) {
      // do nothing
  }
}

function getDataStorage(id) {
  try {
    const rawData = window.localStorage.getItem(id)
    return rawData ? JSON.parse(rawData) : undefined
  } catch (e) {
    return undefined
  }
}

function openSearch(id) {
  // var elems = document.querySelectorAll(`#${id}`);
  // var inputelems = document.querySelectorAll('.search-input');
  // var index = 0, length = elems.length;
  // for ( ; index < length; index++) {
  //   elems[index].style.display = "block";
  //   inputelems[index].focus();
  // }

  document.querySelector(`#${id}`).classList.add("search-active");
  document.querySelector('.search-input').focus();
  document.body.style.overflow = "hidden";
  // document.body.classList.add('is-modal-open', 'overflow-hidden');
}

function closeSearch(id) {
  // var elems = document.querySelectorAll(`#${id}`);
  // var inputelems = document.querySelectorAll('.search-input');
  // var index = 0, length = elems.length;
  // for ( ; index < length; index++) {
  //   elems[index].style.display = "none";
  //   inputelems[index].focus();
  // }

  document.querySelector(`#${id}`).classList.remove("search-active");
  document.body.style.overflow = "auto";
  // document.body.classList.remove('is-modal-open', 'overflow-hidden');
}